module.exports = __webpack_public_path__ + "static/media/APP_Ranger_152x174_1-03.ebcb3434.png";